import React from 'react';

import styled from '@emotion/styled';

import { IGetCreatedJobs } from '../../models/dashboard/jobs/getCreatedJobs.model';
import {
  extractTextFromHTML,
  truncateText,
  truncateTextByCharacters,
} from '../../utils/utils';
import Img from '../Img/Img';
// import { ToggleButton } from '../ToggleButton/ToggleButton';
import { useNavigate } from 'react-router';
import { DASHBOARD, MANAGE_POSTED_JOBS } from '../../routes/routeConstants';

interface IPostedJobsCard {
  job: IGetCreatedJobs; // Change to accept a single job
}

const PostedJobsCard: React.FC<IPostedJobsCard> = ({ job }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/${DASHBOARD}/${MANAGE_POSTED_JOBS}/${job.id}`);
  };

  return (
    <Container onClick={handleClick}>
      <UpperSection>
        <ImageContainer>
          <Img src={'/static/gif/happyAnimal.gif'} alt="job" />
        </ImageContainer>
        <div>
          <UpperSectionTitle>{job.title}</UpperSectionTitle>
          <UpperSectionDescription>
            <span>
              {(() => {
                const text = extractTextFromHTML(job?.jobDescription);
                const first20 = text.slice(0, 20);
                const spaceCount = (first20.match(/ /g) || []).length;
                return spaceCount < 4
                  ? truncateTextByCharacters(text, 30)
                  : truncateText(text, 9);
              })()}
            </span>
          </UpperSectionDescription>
        </div>
        {/* <ToggleButton
          controller={() => console.log('Toggle')}
          defaultState={job.isPublished}
        /> */}
        {job.isPublished ? <Indicator1 /> : <Indicator2 />}
      </UpperSection>
      <BottomSection>
        <FlexContainer>
          <BottomSectionLabel>Contract Period</BottomSectionLabel>
          <BottomSectionLabel>Pay</BottomSectionLabel>
        </FlexContainer>
        <FlexContainer>
          <BottomSectionData>
            {job.jobStartDate
              ? new Date(job.jobStartDate).toLocaleDateString()
              : 'N/A'}{' '}
            <span>&mdash;</span>{' '}
            {job.jobEndDate
              ? new Date(job.jobEndDate).toLocaleDateString()
              : 'N/A'}
          </BottomSectionData>
          <BottomSectionData>{job.pay.formatCurrency()}</BottomSectionData>
        </FlexContainer>
      </BottomSection>
    </Container>
  );
};

export default PostedJobsCard;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  color: black;
  border-radius: 0.25rem;
  background-color: ${({ theme }) => theme.palette.backgroundColor};
  min-height: 11rem;
  max-height: 12rem;
  overflow: hidden;
`;

const UpperSection = styled.div`
  display: grid;
  grid-template-columns: 50px auto 34px;
  gap: 0.5rem;
  padding: 0.875rem;

  @media (max-width: 480px) {
    grid-template-columns: 50px auto 14px;
  }
`;

const UpperSectionTitle = styled.div`
  font-size: 1.25rem;
  font-weight: 400;
  line-height: normal;

  //mobile-specific styles
  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const UpperSectionDescription = styled.div`
  font-size: 0.872rem;
  font-weight: 300;
  color: ${({ theme }) => theme.palette.greyGrey1};

  //mobile-specific styles
  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

const ImageContainer = styled.div`
  height: fit-content;
  border-radius: 50%;
`;

const BottomSection = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0.5rem 0.875rem;
  border-top: 1px solid ${({ theme }) => theme.palette.borderColor};
`;

const BottomSectionLabel = styled.div`
  font-size: 1.25rem;
  font-weight: 400;
  line-height: normal;
  color: ${({ theme }) => theme.palette.greyGrey2};

  //mobile-specific styles
  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

const BottomSectionData = styled.div`
  font-size: 1.1rem;
  font-weight: 400;
  line-height: normal;
  color: ${({ theme }) => theme.palette.blackBlackMain};

  //mobile-specific styles
  @media (max-width: 768px) {
    font-size: 12px;
  }
`;

const FlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Indicator1 = styled.div`
  width: 0.7rem;
  height: 0.7rem;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.palette.stateColorGreen};
`;

const Indicator2 = styled.div`
  width: 0.7rem;
  height: 0.7rem;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.palette.greyGrey2};
`;
